'use client';

import { getToken } from '@/lib/auth';
import { useAuthGate } from '@/context/AuthGateContext';
import { useUserData } from '@/context/UserDataContext';

function CalendarCheckIcon({ active }: { active: boolean }) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor"
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2.5" y="3.5" width="13" height="12" rx="2" fill={active ? '#E8F0E4' : 'none'} />
      <path d="M5.5 2V5M12.5 2V5M2.5 7H15.5" />
      <path d="M6 11L8 13L12 9" />
    </svg>
  );
}

export default function PlanToPlantToggle({
  plantId,
  plantName,
}: {
  plantId: string;
  plantName: string;
}) {
  const { triggerAuthGate } = useAuthGate();
  const { plannedPlants, savePlannedPlants } = useUserData();
  const planned = plannedPlants.includes(plantId);

  function handleClick() {
    if (!getToken()) {
      triggerAuthGate();
      return;
    }

    void savePlannedPlants(currentPlannedPlants =>
      currentPlannedPlants.includes(plantId)
        ? currentPlannedPlants.filter(id => id !== plantId)
        : Array.from(new Set([...currentPlannedPlants, plantId])),
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-pressed={planned}
      aria-label={planned ? `Remove ${plantName} from plan to plant` : `Plan to plant ${plantName}`}
      className={`inline-flex h-9 items-center gap-1.5 rounded-lg border px-3 font-body text-[13px] font-semibold transition-colors duration-200 ${
        planned
          ? 'border-[#C5D9B8] bg-light-sage text-deep-green'
          : 'border-sand text-sage hover:border-sage hover:bg-cream'
      }`}
    >
      <span className="flex-shrink-0">
        <CalendarCheckIcon active={planned} />
      </span>
      Plan to Plant
    </button>
  );
}
